<template>

  <!-- <div>
    <p>付費結果</p>
    <p>orderId:{{ orderId }}</p>
    <p>orderId:{{ transactionId }}</p>
    <p>returnCode:{{ returnCode }} <b v-if="returnCode == '0000'">付款成功</b></p>

  </div> -->

  <!-- success -->
  <div v-if="returnCode == '0000'" class="absoluteFlexCenter p-4">
    <div class="text-center">
      <img src="@/assets/img/check-circle.svg" width="180px" height="180px">
      <p><b>訂閱成功！</b></p>
    </div>
    <div class="mw-640 mx-auto">
      <p class="text-center">感謝您選擇了小美秘書！<br>我們非常榮幸能夠為您服務，並竭盡所能地為您提供優質的體驗。</p>
      <!-- <div>
        <p><b>以下是一些提示，讓您更好地使用小美秘書：</b></p>
        <p>
          <b>探索功能：</b>請隨心瀏覽我們的平台，發現豐富的功能和工具，以滿足您的各種需求。<br>
          <b>常見問題解答：</b>若有疑問，請查閱我們的常見問題解答，可能已經包含您所需要的解答。<br>
          <b>客戶支援：</b>我們的客戶支援團隊隨時為您提供協助。不論是疑問還是需要幫助，都歡迎隨時聯絡我們。<br>
          <b>訂閱資訊：</b>您的訂閱詳情可在個人帳戶頁面查閱，包括訂單狀態、支付資訊等。<br>
          <b>最新消息：</b>請持續關注我們的最新消息和更新，以確保您始終擁有最佳的使用體驗。
        </p>
        <p>再次感謝您信任並選擇小美秘書。我們期待能夠為您提供卓越的服務體驗！</p>
      </div> -->
      <p class="text-center">您可以即刻開始使用服務，祝您使用愉快！</p>
    </div>
  </div>

  <!-- failed -->
  <div v-if="returnCode != '0000' && returnCode != ''" class="absoluteFlexCenter">
    <div class="text-center">
      <svg class="dark-mix-white-80 mb-3" width="120px" height="120px"><use xlink:href="#warning"/></svg>
      <p>
        <b>訂閱失敗</b><br>
        交易過程中發生問題。<br>
        請稍候再試。
      </p>
      <router-link to="/plan" role="button" class="btn btn-primary text-white">了解並返回</router-link>
    </div>
  </div>

</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import axios from 'axios';
//import liff from '@line/liff';
let api_url = process.env.VUE_APP_API_URL;

export default {
  name: 'ConfirmView',
  data () {
    return {
      returnCode: ''
    }
  },
  computed: {

    ...mapGetters(['token']),

    orderId() {
      return this.$route.query.orderId;
    },
    transactionId() {
      return this.$route.query.transactionId;
    },
    status() {
      return this.$route.query.status;
    }
  },
  mounted() {

    if (!this.token) {
      this.$router.replace('/me?page=plan');
    }

    if (this.status == "active_trial") {
      console.log("試用中");
      this.returnCode = "0000";
      return;
    }

    if (this.orderId && this.transactionId) { // 交易確認

      this.confirm_payment().then((res) => {
        if(res) {
          /* liff.sendMessages([{
            type: 'text',
            text: '訂閱成功了😉'
          }]); */
          console.log("訂閱成功");
        } else {
          console.log("訂閱失敗");
        }
      });

    } else {
      console.log("錯誤的連結");
      this.$router.push('/');
    }

  },
  methods: {

    ...mapActions(['setToken', 'clearToken']),

    async confirm_payment() {
        try {
          const baseURL = `${api_url}/confirm_payment`;

          const response = await axios.post(baseURL, {
            order_id: this.orderId,
            transaction_id: this.transactionId
          });

          this.returnCode = response.data.payment_result.returnCode;

          if (response.data.payment_result.returnCode == "0000") {
            return true;
          } else {
            return false;
          }
        } catch (error) {
          console.error('Error sending POST request:', error);
          return false;
        }
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

</style>
